module.exports = __webpack_public_path__ + "img/logo-dark.39fad51d.png";